import { Route } from 'vue-router';

const LoginComponent = () => import('@/components/LoginComponent.vue');
const home = () => import('@/components/home.vue');

// const QuickCode = () => import('@/components/quick_codes/QuickCode.vue');
// const EditQuickCode = () => import('@/components/quick_codes/EditQuickCode.vue');

const Opportunities = () => import('@/components/spaces/Opportunities.vue');
const Spaces = () => import('@/components/spaces/Spaces.vue');
const ViewSpace = () => import('@/components/spaces/ViewSpace.vue');
const ViewSpaceWithQC = () => import('@/components/spaces/ViewSpaceWithQC.vue');
const AddSpace = () => import('@/components/spaces/AddSpace.vue');
const AddSpaceQCSelection = () => import('@/components/spaces/AddSpaceQCSelection.vue');
const AddSpaceSelectedQC = () => import('@/components/spaces/AddSpaceSelectedQC.vue');
const EditSpace = () => import('@/components/spaces/EditSpace.vue');
const EditSpaceQuick = () => import('@/components/spaces/EditSpaceQuick.vue');
const comingSoon = () => import('@/components/coming_soon/comingSoon.vue');
const DuplicateSpaceManual = () => import('@/components/spaces/DuplicateSpaceManual.vue');
const DuplicateSpaceQuick = () => import('@/components/spaces/DuplicateSpaceQuick.vue');
const ControlProducts = () => import('@/components/products/viewProducts/ControlProducts.vue');
const AccessoryProducts = () => import('@/components/products/viewProducts/AccessoryProducts.vue');
const PrimaryProducts = () => import('@/components/products/viewProducts/PrimaryProducts.vue');
const ViewProduct = () => import('@/components/products/ViewProduct.vue');
const CreateAccessoryProduct = () => import('@/components/products/createProducts/CreateAccessoryProduct.vue');
const CreatePrimaryProduct = () => import('@/components/products/createProducts/CreatePrimaryProduct.vue');
const CreateControlProduct = () => import('@/components/products/createProducts/CreateControlProduct.vue');
const CreateSolarProduct = () => import('@/components/products/createProducts/CreateSolarProduct.vue');
const EditAccessoryProduct = () => import('@/components/products/editProducts/EditAccessoryProduct.vue');
const EditControlProduct = () => import('@/components/products/editProducts/EditControlProduct.vue');
const EditPrimaryProduct = () => import('@/components/products/editProducts/EditPrimaryProduct.vue');
const DuplicateAccessoryProduct = () => import('@/components/products/duplicateProducts/DuplicateAccessoryProduct.vue');
const DuplicateControlProduct = () => import('@/components/products/duplicateProducts/DuplicateControlProduct.vue');
const DuplicatePrimaryProduct = () => import('@/components/products/duplicateProducts/DuplicatePrimaryProduct.vue');
const tempPrimaryProducts = () => import('@/components/products/viewProducts/tempPrimaryProducts.vue');

// const DesignBox = () => import('@/components/designs/DesignBox.vue');
// const ECMs = () => import('@/components/designs/ECMs.vue');

const ForgotPassword = () => import('@/components/ForgotPassword.vue');
const MissingData = () => import('@/components/spaces/MissingData.vue');
const Installations = () => import('@/components/spaces/Installations.vue');

// const Designs = () => import('@/components/designs/Designs.vue');

const ProductSummary = () => import('@/components/spaces/ProductSummary.vue');
const PurchaseOrderForm = () => import('@/components/procurement/PurchaseOrderForm.vue');
const PurchaseOrders = () => import('@/components/procurement/PurchaseOrders.vue');
const POShipmentForm = () => import('@/components/procurement/POShipmentForm.vue');
const Shipments = () => import('@/components/procurement/Shipments.vue');
const BuildingList = () => import('@/components/buildings/BuildingList.vue');
const BuildingForm = () => import('@/components/buildings/BuildingForm.vue');
const WorkReports = () => import('@/pages/field_operations/work_reports/WorkReports.vue');
const WorkReport = () => import('@/pages/field_operations/work_reports/work_report/WorkReport.vue');
const WorkReportForm = () => import('@/pages/field_operations/work_reports/work_report_form/WorkReportForm.vue');
const QuarterlyEvaluations = () => import('@/pages/operations/human_resources/quarterly_evaluation/QuarterlyEvaluations.vue');
const QuarterlyEvaluationForm = () =>
  import('@/pages/operations/human_resources/quarterly_evaluation/quarterly_evaluation_form/QuarterlyEvaluationForm.vue');
const QuarterlyEmployeeReport = () =>
  import('@/pages/operations/human_resources/quarterly_evaluation/quarterly_employee_report/QuarterlyEmployeeReport.vue');
const ConstructionReportForm = () => import('@/pages/field_operations/construction_reporting/form/ConstructionReportForm.vue');
const ConstructionReporting = () => import('@/pages/field_operations/construction_reporting/ConstructionReporting.vue');
const TimeEntriesAndExpenses = () => import('@/pages/accounting/time_entries/TimeEntriesAndExpenses.vue');
const Timesheets = () => import('@/pages/accounting/timesheets/Timesheets.vue');
const APRecordForm = () => import('@/components/accounting/APRecords/APRecordForm.vue');
const APRecordsList = () => import('@/components/accounting/APRecords/APRecordsList.vue');
const Accounts = () => import('@/pages/customer_relationships_management/accounts/Accounts.vue');
const AccountForm = () => import('@/pages/customer_relationships_management/accounts/account_form/AccountForm.vue');
const Facilities = () => import('@/pages/customer_relationships_management/facilities/Facilities.vue');
const FacilityForm = () => import('@/pages/customer_relationships_management/facilities/facility_form/FacilityForm.vue');
const Contacts = () => import('@/pages/customer_relationships_management/contacts/Contacts.vue');
const ContactForm = () => import('@/pages/customer_relationships_management/contacts/contact_form/ContactForm.vue');
const SalesforceOpportunities = () => import('@/pages/customer_relationships_management/opportunities/Opportunities.vue');
const SalesforceOpportunityForm = () =>
  import('@/pages/customer_relationships_management/opportunities/opportunity_form/OpportunityForm.vue');

// Customer Relationships Management - Project Engines
// const ProjectEngines = () => import('@/pages/customer_relationships_management/project_engines/ProjectEngines.vue');
// const ProjectEngineForm = () =>
//   import('@/pages/customer_relationships_management/project_engines/project_engine_form/ProjectEngineForm.vue');

// Customer Relationships Management - Pre-C
// const PreContractingRecords = () => import('@/pages/customer_relationships_management/pre-contracting/PreContractingRecords.vue');
// const PreContractingForm = () =>
// import('@/pages/customer_relationships_management/pre-contracting/pre-contracting_form/PreContractingForm.vue');

// Customer Relationships Management - Contracted
// const ContractedRecords = () => import('@/pages/customer_relationships_management/contracted/ContractedRecords.vue');
// const ContractedForm = () => import('@/pages/customer_relationships_management/contracted/contracted_form/ContractedForm.vue');

const SOPs = () => import('@/pages/customer_relationships_management/sops/SOPs.vue');
const SOPForm = () => import('@/pages/customer_relationships_management/sops/sop_form/SOPForm.vue');

// Customer Relationships Management - Work Orders
// const WorkOrders = () => import('@/pages/customer_relationships_management/work_orders/WorkOrders.vue');
// const WorkOrderForm = () => import('@/pages/customer_relationships_management/work_orders/work_order_form/WorkOrderForm.vue');

const EmployeeHandbook = () => import('@/pages/operations/human_resources/employee_handbook/EmployeeHandbook.vue');
const DepartmentOfLaborNotifications = () =>
  import('@/pages/operations/human_resources/department_of_labor_notifications/DepartmentOfLaborNotifications.vue');
const OshaForm = () => import('@/pages/operations/human_resources/osha_form/OshaForm.vue');
const TerminationForm = () => import('@/pages/operations/human_resources/termination_form/TerminationForm.vue');
const TerminationRecords = () => import('@/pages/operations/human_resources/termination_records/TerminationRecords.vue');
const Roles = () => import('@/pages/admin_portal/roles/Roles.vue');
const RoleForm = () => import('@/pages/admin_portal/roles/role_form/RoleForm.vue');
const UserForm = () => import('@/pages/admin_portal/users/user_form/UserForm.vue');
const AllUsers = () => import('@/pages/admin_portal/users/AllUsers.vue');
const Permissions = () => import('@/pages/admin_portal/permissions/Permissions.vue');
const Scheduling = () => import('@/pages/scheduling/Scheduling.vue');
const ImprovementRequests = () => import('@/pages/improvement_requests/ImprovementRequests.vue');
const ChecklistForm = () => import('@/pages/field_operations/checklists/checklist_form/ChecklistForm.vue');
const Checklists = () => import('@/pages/field_operations/checklists/Checklists.vue');
const ImprovementRequestForm = () => import('@/pages/improvement_requests/improvement_request_form/ImprovementRequestForm.vue');

const PurchaseOrderServiceForm = () => import('@/components/procurement/PurchaseOrderServiceForm.vue');
// const ChangeOrderList = () => import('@/pages/change_orders/ChangeOrderList.vue');
// const ChangeOrderForm = () => import('@/pages/change_orders/ChangeOrderForm.vue');
const SolarProducts = () => import('@/components/products/viewProducts/SolarProducts.vue');
const PermissionDenied = () => import('@/components/generic/PermissionDenied.vue');
const CorpSchedule = () => import('@/pages/scheduling/CorpSchedule.vue');
const CorporateExpense = () => import('@/components/accounting/CorporateExpense/CorporateExpense.vue');
const CorpScheduleList = () => import('@/pages/scheduling/CorpScheduleList.vue');
const SubmittalList = () => import('@/pages/submittals/SubmittalList.vue');
const SubmittalForm = () => import('@/pages/submittals/SubmittalForm.vue');
const OpportunityCentric = () => import('@/pages/opportunity/OpportunityCentric.vue');
const SchedulingTemplate = () => import('@/components/scheduling/SchedulingTemplate.vue');
const SchedulingTemplateList = () => import('@/components/scheduling/SchedulingTemplateList.vue');
const OpportunitySchedulePicker = () => import('@/components/scheduling/OpportunitySchedulePicker.vue');
const OpportunitySchedule = () => import('@/components/scheduling/OpportunitySchedule.vue');
const HealthcareBenefits = () => import('@/pages/operations/human_resources/Healthcare/HealthcareBenefits.vue');
const ProjectFinanceTemplate = () => import('@/components/projectFinance/ProjectFinanceTemplate.vue');
const ProjectFinanceVersionPicker = () => import('@/components/projectFinance/ProjectFinanceVersionPicker.vue');
const ProjectFinanceEstimation = () => import('@/components/projectFinance/ProjectFinanceEstimation.vue');
const EmployeeHandbookReport = () => import('@/pages/operations/human_resources/employee_handbook/EmployeeHandbookReport.vue');
const GFormIframe = () => import('@/components/gformIframe/GFormIframe.vue');
const ProjectFinanceServices = () => import('@/components/projectFinance/ProjectFinanceServices.vue');
const ProjectFinanceGroupPicker = () => import('@/components/projectFinance/ProjectFinanceGroupPicker.vue');
const ProjectFinanceCompare = () => import('@/components/projectFinance/compareComponents/ProjectFinanceCompare.vue');
const ProjectFinanceGroupTotals = () => import('@/components/projectFinance/groupTotal/ProjectFinanceGroupTotals.vue');
const CorporateRates = () => import('@/components/accounting/CorporateRate/CorporateRates.vue');
const CorporateRoster = () => import('@/components/accounting/CorporateRate/CorporateRoster.vue');
const ManagerOverview = () => import('@/components/projectFinance/overviews/manager/ManagerOverview.vue');
const PositionAgreementForm = () => import('@/pages/operations/human_resources/position_agreements/PositionAgreementForm.vue');
const PositionAgreements = () => import('@/pages/operations/human_resources/position_agreements/PositionAgreements.vue');
const PayrollDeductionAuthorizationList = () => import('@/components/talent/payroll_deduction/PayrollDeductionAuthorizationList.vue');
const PayrollDeductionAuthorizationForm = () => import('@/components/talent/payroll_deduction/PayrollDeductionAuthorizationForm.vue');
const ApprenticeRequestTrackerList = () => import('@/components/ira/ApprenticeRequestTracker/ApprenticeRequestTrackerList.vue');
const ApprenticeRequestTrackerForm = () => import('@/components/ira/ApprenticeRequestTracker/ApprenticeRequestTrackerForm.vue');
const CertifiedPayrollList = () => import('@/components/certifiedPayroll/CertifiedPayrollList.vue');
const CertifiedPayrollRecord = () => import('@/components/certifiedPayroll/CertifiedPayrollRecord.vue');
const CertificateOfInsuranceList = () => import('@/components/compliance/certificateOfInsurance/CertificateOfInsuranceList.vue');
const CertificateOfInsuranceRecord = () => import('@/components/compliance/certificateOfInsurance/CertificateOfInsuranceRecord.vue');
const PFExportTemplatesList = () => import('@/components/projectFinance/exportTemplates/PFExportTemplatesList.vue');
const PFExportTemplateForm = () => import('@/components/projectFinance/exportTemplates/PFExportTemplateForm.vue');
const PicklistList = () => import('@/components/picklists/PicklistList.vue');
const ActivityForm = () => import('@/components/tasks/ActivityForm.vue');

export const routes = [
  { path: '/', name: 'LoginComponent', component: LoginComponent, meta: { plainLayout: true, notRequiredAuth: true } },
  { path: '/continuous_improvement', name: 'ContinuousImprovement', component: ImprovementRequests, meta: { containerFluid: true } },
  { path: '/continuous_improvement/new', name: 'ContinuousImprovementForm', component: ImprovementRequestForm },
  { path: '/continuous_improvement/:id', name: 'ContinuousImprovementEdit', component: ImprovementRequestForm },
  { path: '/opportunities', name: 'Opportunities', component: Opportunities },
  { path: '/contacts/new', name: 'ContactForm', component: ContactForm },
  { path: '/contacts/:id', name: 'ContactEdit', component: ContactForm },
  { path: '/contacts', name: 'Contacts', component: Contacts },
  { path: '/timesheets', name: 'Timesheets', component: Timesheets },
  { path: '/time_entries_expenses', name: 'TimeEntriesAndExpenses', component: TimeEntriesAndExpenses, meta: { containerFluid: true } },
  { path: '/corporateRates', name: 'CorporateRates', component: CorporateRates, meta: { containerFluid: true } },
  { path: '/corporateRoster', name: 'CorporateRoster', component: CorporateRoster, meta: { containerFluid: true } },
  { path: '/manager-overview', name: 'ManagerOverview', component: ManagerOverview, props: true, meta: { containerFluid: true } },
  {
    path: '/APRecords',
    name: 'APRecordsList',
    component: APRecordsList,
    meta: { containerFluid: true },
    children: [
      {
        path: 'purchaseOrders/:purchaseOrderId',
        name: 'APL_PurchaseOrderView',
        component: PurchaseOrderForm,
        props: true,
        meta: {
          externalLink: (route: Route) => ({ name: 'PurchaseOrderView', params: { purchaseOrderId: route.params.purchaseOrderId } }),
        },
      },
      {
        path: 'purchaseOrders/s/:purchaseOrderId',
        name: 'APL_PurchaseOrderViewService',
        component: PurchaseOrderServiceForm,
        props: true,
        meta: {
          externalLink: (route: Route) => ({ name: 'PurchaseOrderViewService', params: { purchaseOrderId: route.params.purchaseOrderId } }),
        },
      },
      {
        path: 'purchaseOrders/c/:purchaseOrderId',
        name: 'APL_PurchaseOrderViewOPEX',
        component: PurchaseOrderServiceForm,
        props: true,
        meta: {
          externalLink: (route: Route) => ({ name: 'PurchaseOrderViewOPEX', params: { purchaseOrderId: route.params.purchaseOrderId } }),
        },
      },
    ],
  },
  {
    path: '/APRecords/o/:opportunityID',
    name: 'APRecordsListByOpptyID',
    component: APRecordsList,
    props: true,
    meta: { containerFluid: true },
  },
  { path: '/APRecords/new', name: 'NewAPRecord', component: APRecordForm, meta: { containerFluid: true } },
  { path: '/APRecords/:id', name: 'EditAPRecord', component: APRecordForm, props: true, meta: { containerFluid: true } },
  { path: '/APRecords/clone/:id', name: 'CloneAPRecord', component: APRecordForm, props: true, meta: { containerFluid: true } },
  { path: '/position-agreements/new', name: 'PositionAgreementNew', component: PositionAgreementForm },
  { path: '/position-agreements/:id', name: 'PositionAgreementEdit', component: PositionAgreementForm },
  { path: '/position-agreements', name: 'PositionAgreements', component: PositionAgreements },
  { path: '/accounts', name: 'Accounts', component: Accounts },
  { path: '/accounts/new', name: 'AccountNew', component: AccountForm },
  { path: '/accounts/:id', name: 'AccountEdit', component: AccountForm },
  { path: '/facilities', name: 'Facilities', component: Facilities },
  { path: '/facilities/new', name: 'FacilityNew', component: FacilityForm },
  { path: '/facilities/:id', name: 'FacilityEdit', component: FacilityForm },
  { path: '/opportunities-salesforce', name: 'SalesforceOpportunities', component: SalesforceOpportunities },
  { path: '/opportunities-salesforce/new', name: 'SalesforceOpportunityNew', component: SalesforceOpportunityForm },
  {
    path: '/opportunities-salesforce/:id',
    name: 'SalesforceOpportunityEdit',
    component: SalesforceOpportunityForm,
    meta: { opptySearchable: true },
  },

  // ======= Customer Relationships Mananagement - Project Engines ====== //
  // {
  //   path: '/project-engines',
  //   name: 'ProjectEngines',
  //   component: ProjectEngines,
  // },
  // {
  //   path: '/project-engines/new',
  //   name: 'ProjectEngineNew',
  //   component: ProjectEngineForm,
  // },
  // {
  //   path: '/project-engines/:id',
  //   name: 'ProjectEngineEdit',
  //   component: ProjectEngineForm,
  // },

  // ======= Customer Relationships Mananagement - Pre Contracting ====== //
  // {
  //   path: '/pre-contracting',
  //   name: 'PreContractingRecords',
  //   component: PreContractingRecords,
  // },
  // {
  //   path: '/pre-contracting/new',
  //   name: 'PreContractingNew',
  //   component: PreContractingForm,
  // },
  // {
  //   path: '/pre-contracting/:id',
  //   name: 'PreContractingEdit',
  //   component: PreContractingForm,
  // },

  // ======= Customer Relationships Mananagement - Contracted ====== //
  // {
  //   path: '/contracted',
  //   name: 'ContractedRecords',
  //   component: ContractedRecords,
  // },
  // {
  //   path: '/contracted/new',
  //   name: 'ContractedNew',
  //   component: ContractedForm,
  // },
  // {
  //   path: '/contracted/:id',
  //   name: 'ContractedEdit',
  //   component: ContractedForm,
  // },

  // Inspection Checklist
  { path: '/checklists', name: 'Checklists', component: Checklists },
  { path: '/checklists/new', name: 'ChecklistNew', component: ChecklistForm },
  { path: '/checklists/:id', name: 'ChecklistEdit', component: ChecklistForm },
  // ======= Customer Relationships Mananagement - SOPs  ====== //
  { path: '/sops', name: 'SOPs', component: SOPs },
  { path: '/sops/new', name: 'SOPNew', component: SOPForm },
  { path: '/sops/:sopID', name: 'SOPEdit', component: SOPForm, props: true },

  // ======= Customer Relationships Mananagement - Work Orders  ====== //
  // {
  //   path: '/work-orders',
  //   name: 'WorkOrders',
  //   component: WorkOrders,
  // },
  // {
  //   path: '/work-orders/new',
  //   name: 'WorkOrderNew',
  //   component: WorkOrderForm,
  // },
  // {
  //   path: '/work-orders/:id',
  //   name: 'WorkOrderEdit',
  //   component: WorkOrderForm,
  // },

  // ======= Scheduling ====== //

  { path: '/scheduling', name: 'Scheduling', component: Scheduling, meta: { containerFluid: true } },

  // ======= Field Operations (Daily Report) ====== //
  { path: '/work_reports', name: 'WorkReports', component: WorkReports, meta: { allowInstaller: true } },
  { path: '/work_reports/new', name: 'WorkReportForm', component: WorkReportForm, meta: { allowInstaller: true } },
  { path: '/work_reports/:workReportID', name: 'WorkReport', component: WorkReport, meta: { allowInstaller: true } },
  { path: '/work_reports/:workReportID/edit', name: 'WorkReportEdit', component: WorkReportForm, meta: { allowInstaller: true } },

  // ======= Field Operations (Request For Information) ====== //

  {
    path: '/rfi_reports/new',
    name: 'RfiReportForm',
    component: ConstructionReportForm,
    props: { type: 'rfi' },
    meta: { allowInstaller: true },
  },
  {
    path: '/rfi_reports/:id',
    name: 'RfiReportEdit',
    component: ConstructionReportForm,
    props: (route: Route) => ({ id: route.params.id, type: 'rfi' }),
    meta: { allowInstaller: true },
  },

  // ======= Field Operations (Issues) ====== //

  {
    path: '/issues_reports/new',
    name: 'IssuesReportForm',
    component: ConstructionReportForm,
    props: { type: 'issue' },
    meta: { allowInstaller: true },
  },
  {
    path: '/issues_reports/:id',
    name: 'IssuesReportEdit',
    component: ConstructionReportForm,
    props: (route: Route) => ({ id: route.params.id, type: 'issue' }),
    meta: { allowInstaller: true },
  },

  // ======= Field Operations (Punch List) ====== //
  {
    path: '/punch_list_reports/new',
    name: 'PunchListReportForm',
    component: ConstructionReportForm,
    meta: { allowInstaller: true },
    props: { type: 'punchList' },
  },
  {
    path: '/punch_list_reports/:id',
    name: 'PunchListReportEdit',
    component: ConstructionReportForm,
    meta: { allowInstaller: true },
    props: (route: Route) => ({ id: route.params.id, type: 'punchList' }),
  },

  // =========== Field Operations (Space Reporting) ============ //
  { path: '/submitted_reports', name: 'ConstructionReporting', component: ConstructionReporting, meta: { allowInstaller: true } },
  {
    path: '/submitted_reports/:opportunityID',
    name: 'ConstructionReportingByOpportunityID',
    component: ConstructionReporting,
    props: true,
    meta: { allowInstaller: true },
  },

  // =========== Operations Items - Quarterly Evaluation ============= //
  { path: '/quarterly_evaluations', name: 'QuarterlyEvaluations', component: QuarterlyEvaluations },
  { path: '/quarterly_evaluations/new', name: 'QuarterlyEvaluationNew', component: QuarterlyEvaluationForm },
  {
    path: '/quarterly_evaluations/quarterly_employee_report',
    name: 'QuarterlyEmployeeReport',
    component: QuarterlyEmployeeReport,
    meta: { containerFluid: true, fillHeight: true },
  },
  { path: '/quarterly_evaluations/:id', name: 'QuarterlyEvaluationEdit', component: QuarterlyEvaluationForm },
  // =========== Operations Items - Employee Handbook ============= //
  { path: '/employee_handbook', name: 'EmployeeHandbook', component: EmployeeHandbook },
  { path: '/employeeHandbookReport', name: 'EmployeeHandbookReport', component: EmployeeHandbookReport },
  // =========== Operations Items - Healthcare Benefits ============= //
  { path: '/healthcareBenefits/:year/:itemID', name: 'HealthcareBenefits', component: HealthcareBenefits, props: true },

  // =========== Operations Items - Department Of Labor Notifications ============= //
  { path: '/department_of_labor_notifications', name: 'DepartmentOfLaborNotifications', component: DepartmentOfLaborNotifications },

  // =========== OSHA 300 Form ============= //
  { path: '/osha_form', name: 'OshaForm', component: OshaForm },

  // =========== Operations Items - Termination Form / Records ============= //
  { path: '/termination_records/new', name: 'TerminationForm', component: TerminationForm },
  { path: '/termination_records', name: 'TerminationRecords', component: TerminationRecords },
  { path: '/termination_records/:id', name: 'TerminationItem', component: TerminationForm },

  { path: '/spaces/:id', name: 'Spaces', component: Spaces },
  { path: '/view_space/:spaceId/:opportunityId', name: 'ViewSpace', component: ViewSpace },
  { path: '/view_space_with_qc/:spaceId/:opportunityId', name: 'ViewSpaceWithQC', component: ViewSpaceWithQC },
  { path: '/add_space/:opportunityId', name: 'AddSpace', component: AddSpace },
  { path: '/add_space_qc_selection/:opportunityId', name: 'AddSpaceQCSelection', component: AddSpaceQCSelection },
  { path: '/add_space_selected_qc/:opportunityId/:qcId', name: 'AddSpaceSelectedQC', component: AddSpaceSelectedQC },
  { path: '/edit_space/:opportunityId/:spaceId', name: 'EditSpace', component: EditSpace },
  { path: '/duplicate_space/:opportunityId/:spaceId/:options', name: 'DuplicateSpaceManual', component: DuplicateSpaceManual },
  { path: '/duplicate_space_quick/:opportunityId/:spaceId/:options', name: 'DuplicateSpaceQuick', component: DuplicateSpaceQuick },
  { path: '/edit_space_quick/:opportunityId/:spaceId', name: 'EditSpaceQuick', component: EditSpaceQuick },
  { path: '/coming_soon', name: 'comingSoon', component: comingSoon },
  { path: '/home', name: 'home', component: home },

  // -------- Admin Portal - Roles ---------- //
  { path: '/roles', name: 'Roles', component: Roles },
  { path: '/roles/new', name: 'RoleNew', component: RoleForm },
  { path: '/roles/:id', name: 'RoleView', component: RoleForm },

  // -------- Admin Portal - Users ------- //
  { path: '/users', name: 'Users', component: AllUsers },
  { path: '/users/new', name: 'New User', component: UserForm },
  { path: '/users/:id', name: 'UserEdit', component: UserForm },
  // -------- Admin Portal - Users ---------- //
  { path: '/permissions', name: 'permissions', component: Permissions },
  { path: '/control_products', name: 'ControlProducts', component: ControlProducts },
  { path: '/accessory_products', name: 'AccessoryProducts', component: AccessoryProducts },
  { path: '/solar_products', name: 'SolarProducts', component: SolarProducts },
  { path: '/primary_products', name: 'PrimaryProducts', component: PrimaryProducts },
  { path: '/view_product/:productId', name: 'ViewProduct', component: ViewProduct },
  { path: '/create_primaryProduct', name: 'CreatePrimaryProduct', component: CreatePrimaryProduct },
  { path: '/create_controlProduct', name: 'CreateControlProduct', component: CreateControlProduct },
  { path: '/create_accessoryProduct', name: 'CreateAccessoryProduct', component: CreateAccessoryProduct },
  { path: '/create_solarProduct', name: 'CreateSolarProduct', component: CreateSolarProduct },
  { path: '/edit_accessoryProduct/:id', name: 'EditAccessoryProduct', component: EditAccessoryProduct },
  { path: '/edit_SolarProduct/:id', name: 'EditSolarProduct', component: CreateSolarProduct },
  { path: '/edit_controlProduct/:id', name: 'EditControlProduct', component: EditControlProduct },
  { path: '/edit_primaryProduct/:id', name: 'EditPrimaryProduct', component: EditPrimaryProduct },
  { path: '/duplicate_accessoryProduct/:id', name: 'DuplicateAccessoryProduct', component: DuplicateAccessoryProduct },
  { path: '/duplicate_solarProduct/:id', name: 'DuplicateSolarProduct', component: CreateSolarProduct },
  { path: '/duplicate_controlProduct/:id', name: 'DuplicateControlProduct', component: DuplicateControlProduct },
  { path: '/duplicate_primaryProduct/:id', name: 'DuplicatePrimaryProduct', component: DuplicatePrimaryProduct },
  { path: '/tempPrimaryProducts', name: 'tempPrimaryProducts', component: tempPrimaryProducts },
  // {
  //   path: '/designs/designBox/:opportunityId',
  //   name: 'designBox',
  //   component: DesignBox,
  // },
  // {
  //   path: '/designs/ecms/:opportunityId',
  //   name: 'ECMs',
  //   component: ECMs,
  //   props: true,
  //   meta: {
  //     opptySearchable: true,
  //   },
  // },
  // {
  //   path: '/designs/build_ecms/:opportunityId',
  //   name: 'BuildECMs',
  //   component: BuildECMs,
  // },
  { path: '/forgot_password', name: 'ForgotPassword', component: ForgotPassword, meta: { plainLayout: true, notRequiredAuth: true } },
  { path: '/spaces/:id/missing_data', name: 'MissingData', component: MissingData },
  { path: '/installations/:opportunityId', name: 'Installations', component: Installations },
  { path: '/buildings/:opportunityId', name: 'BuildingList', component: BuildingList, props: true, meta: { opptySearchable: true } },
  {
    path: '/buildings/create/:opportunityID',
    name: 'BuildingFormCreate',
    component: BuildingForm,
    props: true,
    meta: { opptySearchable: true },
  },
  { path: '/buildings/view/:buildingID', name: 'BuildingFormView', component: BuildingForm, props: true },
  {
    path: '/buildings/edit/:buildingID',
    name: 'BuildingFormUpdate',
    component: BuildingForm,
    props: (route: Route) => ({ buildingID: route.params.buildingID, forceEdit: true }),
  },
  { path: '/buildings/clone/:buildingID', name: 'BuildingFormClone', component: BuildingForm },
  // {
  //   path: '/designs/:opportunityId',
  //   name: 'Designs',
  //   component: Designs,
  // },
  {
    path: '/product_summary/:opportunityID',
    name: 'ProductSummary',
    component: ProductSummary,
    props: true,
    meta: { opptySearchable: true },
  },

  // change orders
  // {
  //   path: '/change_orders',
  //   name: 'ChangeOrderList',
  //   component: ChangeOrderList,
  // },
  // {
  //   path: '/change_orders/new',
  //   name: 'ChangeOrderNew',
  //   component: ChangeOrderForm,
  // },
  // {
  //   path: '/change_orders/:changeOrderId',
  //   name: 'ChangeOrderView',
  //   component: ChangeOrderForm,
  //   props: true,
  // },

  // submittals
  {
    path: '/submittals/:opportunityId',
    name: 'SubmittalList',
    component: SubmittalList,
    props: true,
    meta: { containerFluid: true, fillHeight: true, opptySearchable: true },
  },
  { path: '/submittals/:opportunityId/new', name: 'SubmittalNew', component: SubmittalForm, props: true },
  { path: '/submittals/:opportunityId/clone/:submittalId', name: 'SubmittalClone', component: SubmittalForm, props: true },
  { path: '/submittals/:opportunityId/:submittalId', name: 'SubmittalView', component: SubmittalForm, props: true },
  { path: '/gform/:itemID', name: 'EmbeddedGForm', component: GFormIframe, props: true },
  {
    path: '/purchaseOrders/create',
    name: 'PurchaseOrderCreate',
    component: PurchaseOrderForm,
    props: (route: Route) => ({ purchaseOrderData: route.params.purchaseOrderData }),
  },
  { path: '/purchaseOrders/clone/:purchaseOrderId', name: 'ClonePO', component: PurchaseOrderForm, props: true },
  { path: '/purchaseOrders/createCustom/:opportunityID', name: 'PurchaseOrderCreateCustom', component: PurchaseOrderForm, props: true },
  { path: '/purchaseOrders/createOPEX', name: 'PurchaseOrderCreateOPEX', component: PurchaseOrderServiceForm, props: true },
  { path: '/purchaseOrders/viewOPEX/:purchaseOrderId', name: 'PurchaseOrderViewOPEX', component: PurchaseOrderServiceForm, props: true },
  {
    path: '/purchaseOrders/createService/:opportunityID',
    name: 'PurchaseOrderCreateService',
    component: PurchaseOrderServiceForm,
    props: true,
  },
  {
    path: '/purchaseOrders/viewService/:purchaseOrderId',
    name: 'PurchaseOrderViewService',
    component: PurchaseOrderServiceForm,
    props: true,
  },
  { path: '/purchaseOrders/:purchaseOrderId', name: 'PurchaseOrderView', component: PurchaseOrderForm, props: true },
  { path: '/purchaseOrders', name: 'PurchaseOrderList', component: PurchaseOrders },
  { path: '/purchaseOrders/byOppty/:opportunityId', name: 'PurchaseOrderListByOppty', component: PurchaseOrders, props: true },
  { path: '/shipmentFromPO/:purchaseOrderId', name: 'ShipmentCreate', component: POShipmentForm, props: true },
  { path: '/shipments/:shipmentId', name: 'ShipmentView', component: POShipmentForm, props: true },
  { path: '/shipments', name: 'ShipmentList', component: Shipments },
  { path: '/corporateExpense', name: 'CorporateExpense', component: CorporateExpense },
  { path: '/permissionDenied', name: 'PermissionDenied', component: PermissionDenied },
  { path: '/projectFinance/template', name: 'ProjectFinanceTemplate', component: ProjectFinanceTemplate },
  {
    path: '/projectFinance/:opportunityID',
    name: 'ProjectFinancePicker',
    component: ProjectFinanceGroupPicker,
    props: true,
    meta: { opptySearchable: true },
  },
  {
    path: '/projectFinance/:opportunityID/totals',
    name: 'ProjectFinanceTotalView',
    component: ProjectFinanceGroupTotals,
    props: true,
    meta: { opptySearchable: true, containerFluid: true },
  },
  {
    path: '/projectFinance/:opportunityID/services',
    name: 'ProjectFinanceServices',
    component: ProjectFinanceServices,
    props: true,
    meta: { containerFluid: true, fillHeight: true, opptySearchable: true },
    children: [
      // purchase orders
      {
        path: 'purchaseOrders',
        name: 'PFS_PurchaseOrderList',
        component: PurchaseOrders,
        props: (route: Route) => ({ opportunityId: route.params.opportunityID, showNav: false }),
        meta: {
          externalLink: (route: Route) => ({ name: 'PurchaseOrderListByOppty', params: { opportunityId: route.params.opportunityID } }),
        },
      },
      {
        path: 'purchaseOrders/:purchaseOrderId',
        name: 'PFS_PurchaseOrderView',
        component: PurchaseOrderForm,
        props: true,
        meta: {
          externalLink: (route: Route) => ({ name: 'PurchaseOrderView', params: { purchaseOrderId: route.params.purchaseOrderId } }),
        },
      },
      {
        path: 'purchaseOrders/s/:purchaseOrderId',
        name: 'PFS_PurchaseOrderViewService',
        component: PurchaseOrderServiceForm,
        props: true,
        meta: {
          externalLink: (route: Route) => ({ name: 'PurchaseOrderViewService', params: { purchaseOrderId: route.params.purchaseOrderId } }),
        },
      },
      //APRecords
      {
        path: 'APRecords',
        name: 'PFS_APRecords',
        component: APRecordsList,
        props: true,
        meta: {
          externalLink: (route: Route) => ({ name: 'APRecordsListByOpptyID', params: { opportunityID: route.params.opportunityID } }),
        },
      },
      {
        path: 'APRecords/new',
        name: 'PFS_NewAPRecord',
        component: APRecordForm,
        props: true,
        meta: { externalLink: () => ({ name: 'NewAPRecord' }) },
      },
      {
        path: 'APRecords/:id',
        name: 'PFS_EditAPRecord',
        component: APRecordForm,
        props: true,
        meta: { externalLink: (route: Route) => ({ name: 'EditAPRecord', params: { id: route.params.id } }) },
      },
      {
        path: 'APRecords/clone/:id',
        name: 'PFS_CloneAPRecord',
        component: APRecordForm,
        props: true,
        meta: { externalLink: (route: Route) => ({ name: 'CloneAPRecord', params: { id: route.params.id } }) },
      },
    ],
  },
  {
    path: '/projectFinance/:opportunityID/:group',
    name: 'ProjectFinanceVersionPicker',
    component: ProjectFinanceVersionPicker,
    props: true,
  },
  {
    path: '/projectFinance/:opportunityID/:group/compare',
    name: 'ProjectFinanceCompare',
    component: ProjectFinanceCompare,
    props: true,
    meta: { containerFluid: true },
  },
  {
    path: '/projectFinance/:opportunityID/:group/:version',
    name: 'ProjectFinance',
    component: ProjectFinanceEstimation,
    props: true,
    meta: { containerFluid: true },
  },
  // Project Finance Export Templates
  { name: 'PFExportTemplatesList', path: '/pfExportTemplates', component: PFExportTemplatesList, meta: { containerFluid: true } },
  { name: 'PFExportTemplateCreate', path: '/pfExportTemplates/new', component: PFExportTemplateForm, meta: { containerFluid: true } },
  {
    name: 'PFExportTemplateEdit',
    path: '/pfExportTemplates/:id',
    component: PFExportTemplateForm,
    props: true,
    meta: { containerFluid: true },
  },
  { path: '/corpSchedule', name: 'CorpScheduleList', component: CorpScheduleList, meta: { containerFluid: true } },
  {
    path: '/corpSchedule/:scheduleID',
    name: 'CorpScheduleGantt',
    component: CorpSchedule,
    props: true,
    meta: { containerFluid: true, fillHeight: true },
  },
  {
    path: '/schedulingTemplate',
    name: 'SchedulingTemplateList',
    component: SchedulingTemplateList,
    meta: { containerFluid: true, fillHeight: true },
  },
  {
    path: '/schedulingTemplate/:templateID',
    name: 'SchedulingTemplate',
    component: SchedulingTemplate,
    props: true,
    meta: { containerFluid: true, fillHeight: true },
  },
  {
    path: '/scheduling/:opportunityID',
    name: 'OpportunitySchedule',
    component: OpportunitySchedulePicker,
    props: true,
    meta: { containerFluid: true, fillHeight: true, opptySearchable: true },
  },
  {
    path: '/scheduling/:opportunityID/:version',
    name: 'OpportunityScheduleVersion',
    component: OpportunitySchedule,
    props: true,
    meta: { containerFluid: true, fillHeight: true },
  },
  {
    path: '/opportunity/:opportunityID',
    name: 'OpportunityCentric',
    component: OpportunityCentric,
    props: true,
    meta: { containerFluid: true, fillHeight: true, opptySearchable: true },
    children: [
      //buildings
      {
        path: 'buildings/create',
        name: 'Opportunity_BuildingFormCreate',
        component: BuildingForm,
        props: true,
        meta: { externalLink: (route: Route) => ({ name: 'BuildingFormCreate', params: { opportunityID: route.params.opportunityID } }) },
      },
      {
        path: 'buildings/view/:buildingID',
        name: 'Opportunity_BuildingFormView',
        component: BuildingForm,
        props: true,
        meta: { externalLink: (route: Route) => ({ name: 'BuildingFormView', params: { buildingID: route.params.buildingID } }) },
      },
      {
        path: 'buildings/edit/:buildingID',
        name: 'Opportunity_BuildingFormUpdate',
        component: BuildingForm,
        props: (route: Route) => ({ buildingID: route.params.buildingID, forceEdit: true }),
        meta: { externalLink: (route: Route) => ({ name: 'BuildingFormUpdate', params: { buildingID: route.params.buildingID } }) },
      },
      {
        path: 'buildings/clone/:buildingID',
        name: 'Opportunity_BuildingFormClone',
        component: BuildingForm,
        props: true,
        meta: { externalLink: (route: Route) => ({ name: 'BuildingFormClone', params: { buildingID: route.params.buildingID } }) },
      },
      // change orders
      // {
      //   path: 'change_orders/new',
      //   name: 'Opportunity_ChangeOrderNew',
      //   component: ChangeOrderForm,
      //   meta: {
      //     externalLink: { name: 'ChangeOrderNew' },
      //   },
      // },
      // {
      //   path: 'change_orders/:changeOrderId',
      //   name: 'Opportunity_ChangeOrderView',
      //   component: ChangeOrderForm,
      //   props: true,
      //   meta: {
      //     externalLink: (route: Route) => ({
      //       name: 'ChangeOrderView',
      //       params: { changeOrderId: route.params.changeOrderId },
      //     }),
      //   },
      // },
      // product summary
      {
        path: 'purchaseOrders/createService',
        name: 'Opportunity_PurchaseOrderCreateService',
        component: PurchaseOrderServiceForm,
        props: true,
        meta: {
          externalLink: (route: Route) => ({ name: 'PurchaseOrderCreateService', params: { opportunityID: route.params.opportunityID } }),
        },
      },
      {
        path: 'purchaseOrders/createCustom',
        name: 'Opportunity_PurchaseOrderCreateCustom',
        component: PurchaseOrderForm,
        props: true,
        meta: {
          externalLink: (route: Route) => ({ name: 'PurchaseOrderCreateCustom', params: { opportunityID: route.params.opportunityID } }),
        },
      },
      {
        path: 'purchaseOrders/create',
        name: 'Opportunity_PurchaseOrderCreate',
        component: PurchaseOrderForm,
        props: (route: Route) => ({ purchaseOrderData: route.params.purchaseOrderData }),
      },
      // purchase orders
      {
        path: 'purchaseOrders/:purchaseOrderId',
        name: 'Opportunity_PurchaseOrderView',
        component: PurchaseOrderForm,
        props: true,
        meta: {
          externalLink: (route: Route) => ({ name: 'PurchaseOrderView', params: { purchaseOrderId: route.params.purchaseOrderId } }),
        },
      },
      {
        path: 'purchaseOrders/viewService/:purchaseOrderId',
        name: 'Opportunity_PurchaseOrderViewService',
        component: PurchaseOrderServiceForm,
        props: true,
        meta: {
          externalLink: (route: Route) => ({ name: 'PurchaseOrderViewService', params: { purchaseOrderId: route.params.purchaseOrderId } }),
        },
      },
      // shipments
      {
        path: 'shipments/:shipmentId',
        name: 'Opportunity_ShipmentView',
        component: POShipmentForm,
        props: true,
        meta: { externalLink: (route: Route) => ({ name: 'ShipmentView', params: { shipmentId: route.params.shipmentId } }) },
      },
      // daily reports
      { path: 'work_reports/new', name: 'Opportunity_WorkReportForm', component: WorkReportForm, meta: { externalLink: 'WorkReportForm' } },
      {
        path: 'work_reports/:workReportID/edit',
        name: 'Opportunity_WorkReportEdit',
        component: WorkReportForm,
        meta: { externalLink: (route: Route) => ({ name: 'WorkReportEdit', params: { workReportID: route.params.workReportID } }) },
      },
    ],
  },
  // Payroll Deduction Authorization
  {
    name: 'PayrollDeductionAuthorizationList',
    path: '/payrollDeductionAuthorization',
    component: PayrollDeductionAuthorizationList,
    meta: { containerFluid: true },
  },
  { name: 'PayrollDeductionAuthorizationCreate', path: '/payrollDeductionAuthorization/new', component: PayrollDeductionAuthorizationForm },
  {
    name: 'PayrollDeductionAuthorizationEdit',
    path: '/payrollDeductionAuthorization/:id',
    component: PayrollDeductionAuthorizationForm,
    props: true,
  },
  // RAP Certified Apprentice Request Tracker
  { name: 'ApprenticeRequestTrackerList', path: '/rapCARTs', component: ApprenticeRequestTrackerList, meta: { containerFluid: true } },
  { name: 'ApprenticeRequestTrackerAdd', path: '/rapCARTs/new', component: ApprenticeRequestTrackerForm },
  { name: 'ApprenticeRequestTrackerEdit', path: '/rapCARTs/:id', component: ApprenticeRequestTrackerForm, props: true },
  // Certified Payroll
  { name: 'CertifiedPayrollList', path: '/certifiedPayrolls', component: CertifiedPayrollList, meta: { containerFluid: true } },
  { name: 'CertifiedPayrollAdd', path: '/certifiedPayrolls/new', component: CertifiedPayrollRecord },
  { name: 'CertifiedPayrollEdit', path: '/certifiedPayrolls/:id', component: CertifiedPayrollRecord, props: true },
  {
    name: 'CertificateOfInsuranceList',
    path: '/certificatesOfInsurance',
    component: CertificateOfInsuranceList,
    meta: { containerFluid: true },
  },
  {
    name: 'CertificateOfInsuranceAdd',
    path: '/certificatesOfInsurance/new',
    component: CertificateOfInsuranceRecord,
    meta: { containerFluid: true },
  },
  {
    name: 'CertificateOfInsuranceEdit',
    path: '/certificatesOfInsurance/:id',
    component: CertificateOfInsuranceRecord,
    props: true,
    meta: { containerFluid: true },
  },
  { name: 'PicklistList', path: '/picklists', component: PicklistList },
  { name: 'TaskAdd', path: '/task/new', component: ActivityForm },
  { name: 'TaskEdit', path: '/task/:id', component: ActivityForm, props: true },
];
